var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { View } from '@amzn/atoz-web/View';
export var LocationEligibilityPageLayout = function (_a) {
    var locationEligibilityFeature = _a.locationEligibilityFeature, pageHeader = _a.pageHeader;
    return (React.createElement(Wrapper, { dataTestId: "LocationEligibilityPageLayout" },
        pageHeader,
        locationEligibilityFeature));
};
var Wrapper = styledWithTheme(View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: #F2F2F2;\n"], ["\n    background-color: #F2F2F2;\n"])));
var templateObject_1;
